document.addEventListener("click", function(e){

  const link = e.target.closest('a[href="#menu"]');

  if(link){
    e.preventDefault();

    const menuBtn = document.querySelector('.mobileMenu-toggle');

    if(menuBtn){

      menuBtn.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

    }
  }

});